import {SDrawerOrModal, SGeneralForms} from "shj-components";
import {useEffect, useRef, useState} from "react";
import {isEmpty} from "lodash-es";
import {message} from "antd";
import {getSeatIpConfigList, seatAccountSave, seatAccountUpdate} from "@/services/saleOpServices.ts";
import {trimStr} from "@/utils/data.ts";

export const AddOrEdit = (props) => {
  const {record, open, setOpen, onReload, seatPerson} = props

  const formRef = useRef()
  const [btnLoading, setBtnLoading] = useState(false)

  useEffect(() => {
    formRef.current?.onFormRef().resetFields()
    !isEmpty(record) && formRef.current?.onFormRef()?.setFieldsValue(record)
  }, [record]);

  const getOptions = async () => {
    const seatConfigList = await getSeatIpConfigList();
    return Promise.resolve({seatConfigList, seatPerson})
  }

  const onSubmit = () => {
    formRef.current?.onFormRef().validateFields().then(values => {
      setBtnLoading(true)
      const apiUrl = values.id ? seatAccountUpdate : seatAccountSave
      apiUrl(values).then((res: any) => {
        message.success(res.message || '操作成功');
        setOpen(false)
        onReload()
      }).finally(() => {
        setBtnLoading(false)
      })
    })
  }

  return <SDrawerOrModal
      title={(record.id ? '编辑' : '新增')}
      mode="modal"
      open={open}
      loading={btnLoading}
      onCancel={() => setOpen(false)}
      onOk={onSubmit}
      width={500}
  >
    <SGeneralForms
        ref={formRef}
        httpOptionsFn={getOptions}
        layout={'vertical'}
        configs={[
          {
            formItem: [
              {label: 'id', name: 'id', hidden: true},
              {
                label: '通道名称',
                name: 'configId',
                required: true,
                rules: [{required: true, message: '通道名称不能为空'}],
                spanCol: 24,
                type: 'select',
                data: 'seatConfigList',
                comConfig: {fieldNames: {label: 'name', value: 'id'}}
              },
              {
                label: '员工姓名',
                name: 'userId',
                required: true,
                rules: [{required: true, message: '员工姓名不能为空'}],
                spanCol: 24,
                type: 'select',
                data: 'seatPerson',
                comConfig: {
                  fieldNames: {label: 'userName', value: 'ucenterUserId'},
                  onChange: (v, op) => {
                    formRef.current?.onFormRef()?.setFieldValue('workerName', op?.userName);
                  }
                }
              },
              {
                name: 'workerName',
                hidden: true,
              },
              {
                label: '员工登录ID',
                name: 'userId',
                required: true,
                placeholder: '自动根据员工姓名带出',
                rules: [{required: true, message: '员工登录ID不能为空'}],
                spanCol: 24,
                comConfig: {
                  disabled: true,
                }
              },
              {
                label: '登录账号',
                name: 'loginAccount',
                required: true,
                rules: [{required: true, message: '登录账号不能为空'}],
                spanCol: 24,
                comConfig: {
                  showCount: true, maxLength: 50,
                  onChange: (e) => formRef.current?.onFormRef()?.setFieldValue('loginAccount', trimStr(e.target.value))
                }
              },
              {
                label: '第三方呼叫账号',
                name: 'thirdAccount',
                required: true,
                rules: [{required: true, message: '第三方呼叫账号不能为空'}],
                spanCol: 24,
                comConfig: {
                  showCount: true, maxLength: 50,
                  onChange: (e) => formRef.current?.onFormRef()?.setFieldValue('thirdAccount', trimStr(e.target.value))
                }
              },
              {
                label: '第三方呼叫账号密码',
                name: 'password',
                required: true,
                rules: [{required: true, message: '第三方呼叫账号密码不能为空'}],
                spanCol: 24,
                comConfig: {
                  showCount: true, maxLength: 50,
                  onChange: (e) => formRef.current?.onFormRef()?.setFieldValue('password', trimStr(e.target.value))
                }
              },
            ],
          },
        ]}
    />
  </SDrawerOrModal>
}